export default __webpack_public_path__ + "static/media/jack.a65156e4.jpg";